var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"logo",attrs:{"alt":"logo","src":require("./assets/logo.png")}}),_c('NftLock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }